import styled from "styled-components";
import {TopBannerDefaultBox} from "./top-banner.default.box";
import {NEW_LIVE_CASINO_PAGE} from "../../../../themes/css-global-classes";

export const TopBannerMrGreenBox = styled(TopBannerDefaultBox)`

  .${NEW_LIVE_CASINO_PAGE} & {
    padding-bottom: calc(200 / 1750 * 100%);
  }

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    .${NEW_LIVE_CASINO_PAGE} &{
      padding-bottom: calc(260 / 1024 * 100%);
    }
  }

  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    .${NEW_LIVE_CASINO_PAGE} & {
      padding-bottom: calc(105 / 414 * 100%);
    }
  }
`;